export default __webpack_public_path__ + "static/media/banner-2.9499e7b8.jpg";